// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"e0a66083","667":"f9797dd8","871":"fd5e6c0a","977":"6c1bb477"}[chunkId] + ".chunk.js";
};